import { Button, Modal } from '@/components/ui'

import { Payments } from '../../../common/models/orders'

export interface PayInstallmentModalProps {
  open: boolean
  installment: Payments | null
  loading?: boolean
  onOpenChange: (open: boolean) => void
  onConfirm: () => void
}

export function PayInstallmentModal({
  open,
  installment,
  loading,
  onOpenChange,
  onConfirm,
}: PayInstallmentModalProps) {
  return (
    <Modal
      open={open}
      onOpenChange={onOpenChange}
      size="sm"
      title="Charge installment now"
      footer={
        <div className="flex gap-3 justify-end w-full">
          <Button
            variant="primary-bordered"
            size="sm"
            disabled={loading}
            onClick={() => onOpenChange(false)}
          >
            Keep as is
          </Button>
          <Button size="sm" disabled={loading} onClick={onConfirm}>
            Charge now
          </Button>
        </div>
      }
    >
      <p className="text-body-m px-[30px] pb-4">
        A real charge of <strong>{installment ? installment.price : ''}</strong>{' '}
        will be attempted immediately on the buyer&apos;s saved card. The
        payment is processed asynchronously — the installment will show as{' '}
        <strong>Pending</strong> until the provider confirms the result; refresh
        the order shortly to see whether it succeeded or failed.
      </p>
    </Modal>
  )
}
